// Service-Worker-Registrierung auf Basis von workbox-window.
// Update-Muster: der neue Service Worker wartet (kein automatisches skipWaiting im SW),
// der Nutzer bestätigt die Aktualisierung, dann SKIP_WAITING → controlling → ein Reload.
// Das Gegenstück (message-Listener für SKIP_WAITING) liegt in sw-template.js.
import { Workbox } from 'workbox-window';

// Der Browser prüft die SW-Datei nur bei Navigationen - eine lange offene PWA
// erfährt sonst nie von einem Deployment. Deshalb zusätzlich aktiv prüfen.
const UPDATE_CHECK_INTERVAL_MS = 60 * 60 * 1000;

export function register(config) {
  if (process.env.NODE_ENV === 'production' && 'serviceWorker' in navigator) {
    // The URL constructor is available in all browsers that support SW.
    const publicUrl = new URL(process.env.PUBLIC_URL, window.location.href);
    if (publicUrl.origin !== window.location.origin) {
      // Our service worker won't work if PUBLIC_URL is on a different origin
      // from what our page is served on. This might happen if a CDN is used to
      // serve assets; see https://github.com/facebook/create-react-app/issues/2374
      return;
    }

    window.addEventListener('load', () => {
      const swUrl = `${process.env.PUBLIC_URL}/sw.js`;
      const wb = new Workbox(swUrl);

      const promptUserToRefresh = () => {
        const confirmed = window.confirm(
          'Eine aktualisierte Version der App ist verfügbar. Jetzt aktualisieren?'
        );
        if (confirmed) {
          // Der neue SW aktiviert sich daraufhin; das controlling-Event
          // unten lädt die Seite neu.
          wb.messageSkipWaiting();
        }
      };

      // Feuert, wenn ein neuer SW installiert ist und wartet - deckt sowohl ein
      // frisch gefundenes Update als auch einen bereits aus einer früheren
      // Sitzung wartenden Worker ab (wasWaitingBeforeRegister).
      wb.addEventListener('waiting', promptUserToRefresh);

      // Nach SKIP_WAITING übernimmt der neue SW die Kontrolle - dann einmalig
      // neu laden, damit die Seite die neuen Assets bekommt.
      wb.addEventListener('controlling', (event) => {
        if (event.isUpdate) {
          console.log('New service worker controlling - reloading page');
          window.location.reload();
        }
      });

      wb.register()
        .then((registration) => {
          if (config && config.onSuccess) {
            config.onSuccess(registration);
          }
          if (!registration) return;
          const checkForUpdates = () => {
            registration.update().catch((error) => {
              console.warn('Service worker update check failed:', error);
            });
          };
          setInterval(checkForUpdates, UPDATE_CHECK_INTERVAL_MS);
          document.addEventListener('visibilitychange', () => {
            if (document.visibilityState === 'visible') checkForUpdates();
          });
        })
        .catch((error) => {
          console.error('Error during service worker registration:', error);
        });
    });
  }
}

export function unregister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready.then((registration) => {
      registration.unregister();
    });
  }
}
